import React, { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { isNonEmptyString, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import FormHistoryView from "components/FormHistoryView";
import { COLUMN_HEADER_KEYS, PRIVILEGES } from "globals/constants";
import { useDictionary, useFormAccesses, useHasPrivileges } from "hooks";
import { getSubaward } from "store/actions/subaward";
import { subawardSelectors } from "store/selectors";

const SubawardHistoryView = () => {
	const { awardId, subawardId } = useParams();
	const subaward = useSelector(subawardSelectors.subaward);

	const {
		[PRIVILEGES.AWARD_NOTES_READ]: canReadNotes,
	} = useHasPrivileges([
		PRIVILEGES.AWARD_NOTES_READ,
	]);
	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.AWARD, awardId);

	const dictionary = useDictionary("award.history");

	const updateSubawardSelection = subaward => {
		const selections = new Map();
		const awardFeedItem = {
			id: subaward.subawardId,
			awardId: subaward.awardId,
			adminTeamMemberData: subaward.adminTeamMembers,
			adminTeamMembers: isNonEmptyArray(subaward.adminTeamMembers)
				? subaward.adminTeamMembers.map(member => member.fullName).join(", ")
				: ""
		};
		selections.set(subaward.subawardId, awardFeedItem);

		return selections;
	};

	const refreshSubaward = useCallback(() => {
		getSubaward(subawardId, { isRefresh: true });
	}, [ subawardId ]);

	useEffect(() => {
		if (isNonEmptyString(subawardId)) {
			getSubaward(subawardId);
		}
	}, [ subawardId ]);

	return (
		<FormHistoryView
			instance={subaward}
			refreshInstance={refreshSubaward}
			dictionary={dictionary}
			updateInstanceSelection={updateSubawardSelection}
			canReadNotes={canReadNotes}
			canAssign={formAccesses.updateAdminTeam}
			adminRole={"SP Award Administrator"}
			formType={COLUMN_HEADER_KEYS.SUBAWARD}
			formIdKey="subawardId"
		/>
	);
};

export default SubawardHistoryView;
